import React from 'react';
import {Image, StyleSheet, View} from "@react-pdf/renderer";

// Create styles
const styles = StyleSheet.create({
    topper: {
        backgroundColor: '#223e4a',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        width: 595.28,
        height: 94
    },
    header: {
        position: 'absolute',
        top: 20,
        right: 20
    },
    logo: {
        position: 'absolute',
        top: 0,
        right: 0,
        width: 130,
    }
});

const Header = () => (
    <View>
        <View style={styles.topper}></View>
        <View style={styles.header}>
            <Image
            src="https://governwith.s3.ap-southeast-2.amazonaws.com/images/GOVERNWITH_LOGO.png"
            style={styles.logo}
            />
        </View>
    </View>
);

export default Header;
